<template>
  <div>
    <el-select
      v-model="selected"
      :multiple="params.multiple"
      :value-key="params.key"
      filterable
      clearable
      style="width: 100%"
    >
      <el-option
        v-for="(option, index) in items"
        :key="index"
        :label="option[params.label]"
        :value="option"
      />
    </el-select>
    <i v-if="error" class="form-error">{{ error }}</i>
  </div>
</template>

<script>
import { enumFilter } from "@/utils/filters";

export default {
  props: {
    // data: {
    //   type: Array,
    //   required: true,
    // },
    params: {
      type: Object,
      required: true,
    },
    value: {
      type: [Array, String, Number],
      required: false,
      default() {
        const { multiple } = this.params;
        if (multiple) {
          return [];
        }
        return null;
      },
    },
  },
  data() {
    return {
      items: null,
      error: "",
    };
  },
  async mounted() {
    const routeId = this.$route.params.cityId;
    const data = await enumFilter(this.params.alias, routeId);
    this.items = this.filterData(data);
  },
  computed: {
    /**
     * Внутри компонента используем объект с названием и id
     * наружу отдаем массив с id
     */
    selected: {
      get() {
        if (Array.isArray(this.value) && Number(this.value[0])) {
          const asd = this.value.map((e) =>
            this.items.find((item) => item[this.params.key] === e)
          );
          return asd;
        }
        if (typeof this.value !== "object") {
          return this.items.find(
            (item) => item[this.params.key] === this.value
          );
        }
        return this.value;
      },
      set(val) {
        if (
          this.params.max_item === this.selected.length &&
          val.length >= this.selected.length
        ) {
          this.error = "Максимальное количество рекомендаций - 3";
          return;
        }
        if (this.error && val.length < this.selected.length) this.error = "";
        console.log(val);
        this.$emit(
          "input",
          Array.isArray(val)
            ? val.map((e) => e)
            : val[this.params.key] === undefined
            ? null
            : val[this.params.key]
        );
      },
    },
  },
  methods: {
    filterData(data) {
      return data.filter((el) => el.id != this.$route.params.id);
    },
  },
};
</script>

<style lang="postcss" scoped>
.form-error {
  color: red;
}
.error {
  border-color: red;
}
</style>
